import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as i, createElementVNode as a } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconZoomOut",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 5.5A.5.5 0 0 1 4 5h3a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5Z",
  fill: "currentColor"
}, null, -1), _ = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 5.5a4.5 4.5 0 1 1 8.016 2.81l1.838 1.838a.5.5 0 1 1-.707.707L8.309 9.016A4.5 4.5 0 0 1 1 5.5Zm1 0a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
  fill: "currentColor"
}, null, -1), m = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 5.5A.5.5 0 0 1 4 5h3a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5Z",
  fill: "currentColor"
}, null, -1), f = [
  u,
  _,
  m
];
function h(t, p, o, v, b, e) {
  return d(), r("svg", {
    "aria-label": o.ariaLabel,
    class: i([e.iconSizeClass, "d-icon d-icon--zoom-out"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Zoom Out",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, c);
}
const z = /* @__PURE__ */ n(s, [["render", h]]);
export {
  z as default
};
//# sourceMappingURL=zoom-out.js.map
